import { Injectable } from '@angular/core';

import { HttpService, NotificationService, TmsWebBaseEditService } from 'tms-lib';
import { TrimDescription } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class TrimDescriptionService extends TmsWebBaseEditService<TrimDescription, TrimDescription> {
  constructor(protected httpService: HttpService, protected notificationService: NotificationService) {
    super('TrimDescription', $localize`Trim Description`, httpService, notificationService);
  }
}
